exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".responseTile{overflow:hidden}.responseTile .activityTitle,.responseTile .responseBody{padding:10px}.responseTile .responseInfo .responseHeader{position:relative}.responseTile .responseInfo .activityTitle{background-color:#e4e4e4;margin-bottom:0;border-bottom:1px solid #ddd}.responseTile .responseInfo .activityTitle.narrow{padding-right:20px;padding-left:20px}.responseTile .responseInfo .bookTitle{margin-bottom:5px}.responseTile .responseInfo .removeButton{position:absolute;right:4px;top:4px;padding:0;font-size:15px;outline:none;color:#999}.responseTile .responseInfo .removeButton:hover{color:#555}.responseTile .date{display:block;position:relative;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/response_tile.scss
// module id = 1504
// module chunks = 0